// src/components/forms/DatePickerInput.tsx
import type { DatePickerProps as AntdDatePickerProps } from 'antd';
import { DatePicker as AntdDatePicker } from 'antd';
import React from 'react';
type DatePickerProps = AntdDatePickerProps & {
  ariaLabel?: string; // Accessible label for screen readers
  ariaDescribedby?: string; // Link to additional help text
};
const DatePicker: React.FC<DatePickerProps> = ({
  ariaLabel,
  ariaDescribedby,
  ...rest
}) => {
  return (
<AntdDatePicker
      aria-label={ariaLabel} // Accessible label
      aria-describedby={ariaDescribedby} // Link to help text
      {...rest} // Pass other props to DatePicker
    />
  );
};
export default DatePicker; 